import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import RightMenu from "../RightMenu";
import calendar_icon from "../../../assets/images/calendar_icon.png";
import CalendarButton from "../CalendarButton";
import DatePicker from "react-datepicker";
import Dropdown from "../Dropdown";
import plPL from "rc-calendar/lib/locale/pl_PL";
import enGB from "rc-calendar/lib/locale/en_GB";
import moment from "moment";
import PL from "moment/locale/pl";
import EN from "moment/locale/en-gb";
import RightIconMenu from "../RightIconMenu";

export default class View_type_4 extends Component {
  constructor(props) {
    super(props);
    //console.log("View_type_4: ", props);
    {
      this.props.data.calendar_language == "PL"
        ? moment.locale("pl")
        : moment.locale("en-gb");
    }

    const now = moment();
    const defaultCalendarValue = now.clone();
    const dayAndMonth = Object.keys(this.props.data.events);
    const onlyDay = dayAndMonth.map(elem => {
      return elem.split(".")[0];
    });

    let data = {
      title: "",
      calendar: [],
      sort: [],
      prev_dropdown: [],
      events: [],
      calendar_picker: false,
      right_menu: [],
      calendar_year:"",
      ...props.data
    };
    this.state = {
      data: data,
      rightMenu: data.right_menu,
      prevDropdown: data.prev_dropdown,
      date: Object.keys(data.events)[0],
      dateAll: Object.keys(data.events),
      showCalendar: false,
      showMore: false,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
      value: undefined,
      startDate: moment.utc(Object.keys(this.props.data.events)[0],"DD.MM.YYYY") ? moment.utc(Object.keys(this.props.data.events)[0],"DD.MM.YYYY") : moment.utc(new Date(),"DD.MM.YYYY"),
    };
    //console.log("View_type_4:",this.state);


    this.changeDate = this.changeDate.bind(this);
    this.openCalendar = this.openCalendar.bind(this);
  }

  changeDate(date) {
    this.setState(
      {
        date: date.format("DD.MM.YYYY"),
        // startDateCallendar: date,
        startDate: null,
      },
    );
    // this.setState({date: date[0].format("DD.MM")});
    //this.openCalendar();
  }

  openCalendar(event) {
    this.setState(prevState => ({
      showCalendar: !prevState.showCalendar
    }));
  }

  showDescription = () => {
	var element = document.getElementsByClassName("more_button");
	var desc_element = document.querySelector(".description");
	desc_element.classList.toggle("hidden");
  }



  // componentDidMount(){
  //   let splitedDate = document.querySelector('.react-datepicker__currdsdsdent-month')
  //   if (splitedDate) {
  //     let b = splitedDate.innerText.split(' ')[1]
  //     b = "janusz"
  //     // b.innerText = this.state.data.calendar_year;
  //   }
  // }

  render() {
    const selected = {
      border: "1px solid #aa8dc2",
      color: "#666",
      background: "#f4f1f7",
      color: "#a78ac0"
    };
    const dayAndMonth = this.state.dateAll;
    const onlyDay = dayAndMonth.map(elem => {
      return elem.split(".")[0];
    });
    const transformedTime = dayAndMonth;
    // const transformedTimeSplited = transformedTime[0].split(".");
    const transformedTimeSplited = transformedTime[0].split(".");
    const now = moment();
    const defaultCalendarValue = now.clone();
    // const defaultCalendarValue1 = now.clone();

    defaultCalendarValue.date(transformedTimeSplited[2]);
    defaultCalendarValue.add(-transformedTimeSplited[1], "month");

    var events = Object.assign({}, this.state.data.events);
    let _this = this;

    Object.keys(events)
      .reverse()
      .map((key, index) => {
        key !== this.state.date ? delete events[key] : null;
      });

    var left_col =
      this.state.rightMenu.length || this.state.data.calendar_picker ? 9 : 12;
    var right_col = 12 - left_col;




    const calendar =(
      <DatePicker
        dateFormatCalendar="DD.MM.YYYY"
        style={{
          height: "200%!important"
        }}
        inline
        selected={moment.utc(Object.keys(this.state.data.events)[0],"DD.MM.YYYY") ? moment.utc(Object.keys(this.state.data.events)[0],"DD.MM.YYYY") : moment.utc(new Date() , "DD.MM.YYYY")}
        highlightDates={this.state.dateAll.map(elem => {
          return moment.utc(elem,"DD.MM.YYYY");
        })}
        calendarClassName="vt4 absolute_calendar"
        onChange={this.changeDate}
        onSelect={()=>this.handleSelect()}
      />
    )

    return (
      <div className="vt4 main row">
        <div className={"vt4 col-md-12 vt4_content-column col-lg-" + left_col}>
          <div className={"vt4 col-lg-12 artists-pageTitle"}>
            {this.state.data.title}
          </div>
          <div className={"vt4 col-lg-12 top_elements"}>
            <div className="row">
              <div className={"vt4 col-lg-12"}>
                <ul className="vt4 filters">
                  {this.state.data.sort.map((object, i) => (
                    <li className="vt4 calendar-sortunit" key={i}>
                      {object.link == "" ? (
                        object.name
                      ) : (
                        <Link className="calendar-sortitem" to={object.link}>
                          {object.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              {this.state.dateAll.length >= 1 && (
                <div className="vt4 icons col-md-12 hidden-lg">
                  <img
                    className="vt4 calendar_icon"
                    src={calendar_icon}
                    onClick={this.openCalendar}
                  />
                  <div>{this.state.showCalendar && calendar}</div>
                </div>
              )}
            </div>
          </div>

          <div className={"vt4 col-lg-12"}>
            {Object.keys(events).map((key) => {
              let obj = events[key];
             // console.log(obj,'obj');
              return (
                <div className="vt4" key={key}>
                  <div className="vt4 col-lg-12 calendar-timeset">
                    <div className="vt4 calendarTimesetunit">{key}</div>
					<p></p>
                    <div className="vt4 calendarWeekDay" />
                  </div>

                  {Object.keys(obj).map((key1)=> {
                    let item = obj[key1];

                    return (
                      <div className="vt4 row vt4--hover-links calendarMz" key={key1}>
                        <div className="vt4 col-xs-12 col-sm-4 col-md-4 col-lg-4">
                          <div className="vt4 calendarMzName">
                            <div className="vt4 calendarMzNameItem calendarMzTimeItem">
                              {item.time}
                            </div>
                            <div className="vt4 calendarMzNameItem">
                              {item.place}
                            </div>
                          </div>
                        </div>
                        <div className="vt4 col-xs-12 col-sm-5 col-md-5 col-lg-5">
                          <div className="vt4 center">
                            <div className="vt4 calendarContTitle">
                              {item.type}
                            </div>

                            <div className="vt4 calendarParticipantWrapper">
                              {item.artists.map(function(object, i) {
                                return (
                                  <div className="vt4 participantBlock" key={i}>
                                    <span className="vt4 calendarNameParticipant">
                                      <Link to={object.link}>
                                        {object.name}
                                      </Link>
                                    </span>
                                    <span className="vt4 calendarInstrument">
                                      {" "}
                                      {object.instrument}{" "}
                                    </span>
                                  </div>
                                );
                              })}
                              {item.conductor &&
                                item.conductor.map((singleConductor, index) => {
                                  return (
                                    <div className="conductor">
                                      <span className="conductor__name">
                                        <Link to={singleConductor.url}>
                                          {singleConductor.name}
                                        </Link>
                                      </span>
                                      <span className="conductor__description">
                                        {singleConductor.description}
                                      </span>
                                    </div>
                                  );
                                })}
                              {item.orchestra &&
                                item.orchestra.map((singleOrchestra, index) => {
                                  return (
                                    <div className="orchestra">
                                      <div className="orchestra__box__name">
                                        <span className="orchestra__name">
                                          <Link to={singleOrchestra.url}>
                                            {singleOrchestra.name}
                                          </Link>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>

                            <div className="vt4 calendarProgrammBox">
                              PROGRAM
                            </div>
                            <div>
                              {item.lineup && Array.isArray(item.lineup) ? (
                                item.lineup.map((singleAuthor, key) => {
                                  return (
                                    // <Link to = {singleAuthor.url}>
                                    <div
                                      key={key}
                                      className="vt4 calendar-info"
                                    >
                                      {singleAuthor.url.length > 2 ? (
                                        <div>
                                          <p className="vt4 calendar__author-name">
                                            {singleAuthor.author}
                                          </p>
                                          <Link to={singleAuthor.url}>
                                            <div
                                              className="vt4 calendarParticipantExtendet"
                                              dangerouslySetInnerHTML={{
                                                __html: singleAuthor.composition
                                              }}
                                            />
                                          </Link>
                                        </div>
                                      ) : (
                                        <div>
                                          <p className="vt4 calendar__author-name">
                                            {singleAuthor.author}
                                          </p>
                                          <div
                                            className="vt4 calendarParticipantExtendet"
                                            dangerouslySetInnerHTML={{
                                              __html: singleAuthor.composition
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  );
                                })
                              ) : (
                                <div
                                  className="vt4 calendarParticipantExtendet"
                                  dangerouslySetInnerHTML={{
                                    __html: item.lineup
                                  }}
                                />
                              )}
                              {/* </Link> */}
                            </div>

                            {/* <div
															className="vt4 calendarParticipantExtendet"
															dangerouslySetInnerHTML={{ __html: item.lineup.map((elem)=>{
																return elem.composition
															}) }}
														/> */}
                            <div className="vt4 middle-addelem">
                              <AdditionalBlock data={item} />
                            </div>
                          </div>
                          {item.links.map((object, i) => (
                            <span
                              className="vt4 calendarListItemRightMenu mobile--ticket"
                              key={i}
                            >
                              <a target="_blank" href={object.link}>{object.name}</a>
                            </span>
                          ))}
						  {item.description ?
						  (<div className="vt4 middle-addelem">
							  <div className="vt4 more_button" onClick={this.showDescription} ></div>
						  </div>
					  )
						  : null}
                        </div>

                        <div className="vt4 col-xs-3 col-sm-3 col-md-3 col-lg-3 ticket--button">
                          <ul className="vt4 calendarListRightMenu">
                            {item.links.map((object, i) => (
                              <li
                                className="vt4 calendarListItemRightMenu"
                                key={i}
                              >
                                <a target="_blank" href={object.link}>{object.name}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
						{item.description ?
						(<div className="vt4 col-md-12 middle-addelem">
							<p className="vt4 description hidden">{item.description}</p>
						</div>
					)
						: null}

                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div
          className={
            "vt4 right hidden-xs hidden-sm hidden-md vt4_calendar-column vt4_calendar-column--hd  col-lg-" +
            right_col
          }
        >
          {this.state.prevDropdown.length ||
          (Object.keys(this.state.prevDropdown).length &&
            this.state.data.prev_dropdown.current ) ? (
            <Dropdown giveMeClassName={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length>5 ? 'festiwal--dropdown' : 'normal'}`} data={this.state.prevDropdown} />
          ) : null}
          {this.state.rightMenu.length &&
          this.state.data.prev_dropdown.current ? (
            <RightMenu
              // className="vt4 right_menu right_menu--calendar" {...this.state.data} />
              className="vt4 right_menu right_menu--calendar"
              data={this.state.rightMenu}
              {...this.state.data}
            />
          ) : null}
          {this.state.dateAll.length >= 1 &&
            <DatePicker
              dateFormatCalendar="DD.MM.YYYY"
              inline
              selected={this.state.startDate}
              highlightDates={this.state.dateAll.map(elem => {
                return moment.utc(elem,"DD.MM.YYYY");
              })}
              calendarClassName="vt4 calendar_right"
              onChange={this.changeDate}
            />
          }
					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu}/>
					}
        </div>
      </div>
    );
  }
}

class AdditionalBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false
    };
    this.openMore = this.openMore.bind(this);
  }

  openMore(event) {
    this.setState(prevState => ({
      showMore: !prevState.showMore
    }));
  }

  render() {
    const more = this.state.showMore ? (
      <div
        dangerouslySetInnerHTML={{
          __html: this.props.data.additional_information
        }}
      />
    ) : null;
    if (
      this.props.data.hasOwnProperty("additional_information") &&
      this.props.data.additional_information
    ) {
      return (
        <div className="vt4 more_block">
          <button className="vt4 more_button" onClick={this.openMore} />
          <div className="vt4 more_text">{more}</div>
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_4/index.js